const defaultState = {
    loading: false,
    totalCount: 0,
    payments: [],
    subscriptionsLoading: false,
    subscriptions: [],
    subscriptionsTotalCount: 0,
};

const paymentReducer = (
    state = defaultState,
    action
) => {
    switch (action.type) {
        case 'GET_PAYMENTS_REQUEST':
            state = {
                ...state,
                loading: true
            }
            break;
        case 'GET_PAYMENTS_SUCCESS':
            state = {
                ...state,
                loading: false,
                payments: action.payload.payments,
                totalCount: action.payload.totalCount
            }
            break;
        case 'GET_PAYMENTS_FAILURE':
            state = {
                ...state,
                loading: false,
                payments: [],
                totalCount: 0
            }
            break;
        case 'GET_SUBSCRIPTIONS_REQUEST':
            state = {
                ...state,
                subscriptionsLoading: true,
                subscriptionsTotalCount: defaultState.subscriptionsTotalCount,
                subscriptions: defaultState.subscriptions,
            }
            break;
        case 'GET_SUBSCRIPTIONS_SUCCESS':
            state = {
                ...state,
                subscriptionsLoading: false,
                subscriptionsTotalCount: action.payload.totalCount,
                subscriptions: action.payload.subscriptions,
            }
            break; case 'GET_SUBSCRIPTIONS_FAILURE':
            state = {
                ...state,
                subscriptionsLoading: true,
                subscriptionsTotalCount: defaultState.subscriptionsTotalCount,
                subscriptions: defaultState.subscriptions,
            }
            break;
    }
    return state;
};

export default paymentReducer;

